(function( $ ) {
    $(function() {
        function fixedNavOffset(){
            var adminBar = $('#wpadminbar');
            var adminBarHeight;
            if(adminBar.length > 0){
                adminBarHeight = adminBar.height();
                $('.main-header').css('transform', 'translateY('+adminBarHeight+'px)');
            }
        }
        fixedNavOffset();
        // toggle menu icon
        $('.menu-icon').on('click', function(e){
            e.preventDefault();
            $('.menu-holder').toggleClass('open');
        });
        $('.menu-holder').on('click', '.close-btn', function(e){
            e.preventDefault();
            $('.menu-holder').removeClass('open');
        });
        
        $('.menu-item-has-children > a').on('click', function(e){
            e.preventDefault();
        });
        $('.menu-item-has-children > a').on('click', function(e){
            $(this).parent().toggleClass('open');
        });
        $('.home-slider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            fade: true,
            cssEase: 'linear',
            prevArrow: '<button class="slick-prev slick-arrow"></button>',
            nextArrow: '<button class="slick-next slick-arrow"></button>',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
        $('.contact-slider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            fade: true,
            cssEase: 'linear',
            arrows: false
        });
        //Btns blocks
        
        $('.btn-block').on('click', '.close', function(e) {
            $(this).closest('.btn-block').toggleClass('open').siblings('.btn-block').toggleClass('hidden');
            $('.btns-container').toggleClass('open');
            overlay();
        });
        $('.cta-btns-wrapper').on('click', '.cta-btn', function(e) {
            e.preventDefault();
            var thisBtn = $(this);            
            $('.btns-container').toggleClass('open');
            thisBtn.closest('.btn-block').toggleClass('open').siblings('.btn-block').toggleClass('hidden');
            overlay();
            //scroll to clicked target            
            $('body,html').animate({
                scrollTop: thisBtn.offset().top - $('.main-header').outerHeight() - $('#wpadminbar').outerHeight() - 15
            }, 500);
        });
      
        function overlay(){
            var selector = $('.selectorOverlay');
            var el = $('.btn-block.open, .service-block.open, .contact-block.open');
            if(el.length > 0){
                if(selector.length === 0){
                    $('body').append($('<div class="selectorOverlay"></div>').click(function(){
                        el.removeClass('open').siblings('.btn-block').removeClass('hidden');
                        $('.btns-container').removeClass('open');
                        $(this).remove();
                    }));
                }
            }
            else{
                selector.remove();
            }
        }
        function homeBtnsPos(){
            var el = $('.caption-wrapper');
            if(el.length > 0){
                var elWidth = el.outerWidth(true);
                var elLeft = el.offset().left;
                var btnsOffset = elWidth+elLeft+15;            
                $('.btns-home').css('transform', 'translateX('+btnsOffset+'px)');
            }
        }
        homeBtnsPos();
        $(window).on('resize', function(){
            homeBtnsPos();
        });
        //Tabs
        //tabs switch
        $('.tabs-navs').on('click', '.tab-nav-item', function(){
            var thisEL = $(this);
            var elIndex = thisEL.index();
            thisEL.addClass('active').siblings().removeClass('active');
            $('.tab-content-wrapper').show();
            $('.tab-content').eq(elIndex).show().siblings('.tab-content').hide();
            
            $('body,html').animate({
                scrollTop: $('.tabs-navs').offset().top - $('.main-header').outerHeight() - $('#wpadminbar').outerHeight()
            }, 500);
            
        });
        //tabs close
        $('.tabs-contatiner').on('click', '.close', function(){
            $('.tab-content-wrapper').hide();
            $('.tab-nav-item').removeClass('active');
        });
        //Service block
        $('.service-block').on('click', '.close', function(){
            $('.service-block').removeClass('open');
            overlay();
        });
        $('.service-block').on('click', '.title', function(e){
            var thisBtn = $(this);
            thisBtn.closest('.service-block').toggleClass('open');
            overlay();
            //scroll to clicked target
            $('body,html').animate({
                scrollTop: thisBtn.offset().top - $('.main-header').outerHeight() - $('#wpadminbar').outerHeight() - 15
            }, 500);
        });
        //Contact block
        $('.contact-block').on('click', '.close', function(){
            $('.contact-block').removeClass('open');
            overlay();
        });
        $('.contact-block').on('click', '.title', function(e){
            var thisBtn = $(this);
            thisBtn.closest('.contact-block').toggleClass('open');
            overlay();
            //scroll to clicked target
            $('body,html').animate({
                scrollTop: thisBtn.offset().top - $('.main-header').outerHeight() - $('#wpadminbar').outerHeight() - 15
            }, 500);
        });
        ///Header images slider
        $('.header-image-slider').slick({
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
        //Services page toggler
        $('.service-block-wrapper .single-block:not(:first-child)').on('click', '.title', function(){
            $(this).siblings('.content').toggle();
        });
        $(window).load(function(){
            //links to anchors on window load
            var headerBoxHeight_ = $('.main-header').outerHeight() + $('#wpadminbar').outerHeight();
            var hash = window.location.hash;
            if(hash.length > 0) {
                var target = $('[id=' + window.location.hash.slice(1) +']');
                $('html,body').animate({
                    scrollTop: target.offset().top - headerBoxHeight_
                }, 1000);            
            }        
        });
        //Gallery
        $(".fancybox").fancybox({
            padding     : 0,
            maxWidth    : '100%',
            maxHeight   : 600,
            fitToView   : false,
            width       : '90%',
            height      : '90%',
            autoSize    : true,
            closeClick  : false,
            openEffect  : 'elastic',
            closeEffect : 'elastic',
            prevEffect  : false,
            nextEffect  : false,
            fixed       : false,
            autoCenter  : true
        });
//        $('.fancybox-media').on('click', function(e){
//            e.preventDefault();
//        });
        $('.fancybox-media').fancybox({
                padding     : 0,
                maxWidth    : '100%',
                maxHeight   : 600,
                fitToView   : false,
                width       : '90%',
                height      : '90%',
                autoSize    : true,
                closeClick  : false,
                openEffect  : 'elastic',
                closeEffect : 'elastic',
                prevEffect  : false,
                nextEffect  : false,
                fixed       : false,
                autoCenter  : true,
                type: 'iframe',
		helpers : {
			media : {}
		}
	});
        $('.mobile-cta-btn').on('click', '.close', function(e){
            e.preventDefault();
            $(this).closest('.mobile-cta-btn').removeClass('opened');
        });
        $('.mobile-cta-btn').on('click', '.open-cta', function(e){
            e.preventDefault();
            $(this).closest('.mobile-cta-btn').toggleClass('opened');
        });
    });
})(jQuery);